var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8f8f8f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.582,8.438a1.574,1.574,0,0,0,1.1-.445l1.561.78a1.549,1.549,0,0,0-.019.192,1.582,1.582,0,1,0,3.164,0,1.563,1.563,0,0,0-.159-.678L40.342,6.17a1.563,1.563,0,0,0,.678.159A1.584,1.584,0,0,0,42.6,4.746a1.558,1.558,0,0,0-.079-.469l1.84-1.38a1.581,1.581,0,1,0-.706-1.316,1.558,1.558,0,0,0,.079.469L41.9,3.43a1.575,1.575,0,0,0-2.3,1.994L37.479,7.541a1.555,1.555,0,0,0-1.773.286l-1.561-.78a1.549,1.549,0,0,0,.019-.192,1.582,1.582,0,1,0-1.582,1.582Zm0,0",
    transform: "translate(-29.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.473,161.672H16.91V150.527a.527.527,0,0,0-.527-.527H14.273a.527.527,0,0,0-.527.527v11.145H12.691v-7.98a.527.527,0,0,0-.527-.527H10.055a.527.527,0,0,0-.527.527v7.98H8.473V157.91a.527.527,0,0,0-.527-.527H5.836a.527.527,0,0,0-.527.527v3.762H4.254V155.8a.527.527,0,0,0-.527-.527H1.617a.527.527,0,0,0-.527.527v5.871H.527a.527.527,0,0,0,0,1.055H17.473a.527.527,0,0,0,0-1.055Zm0,0",
    transform: "translate(0 -144.727)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.fca6499d.svg";
export { ForwardRef as ReactComponent };